var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlidericonh4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.936,
    height: 150.936,
    viewBox: "0 0 150.936 150.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_111",
    x: 0,
    y: 0,
    width: 150.936,
    height: 150.936,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a7cafd",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(-3975.5 -2920)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3975.5, 2920)",
    filter: "url(#Rectangle_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 94,
    height: 94,
    rx: 30,
    transform: "translate(13 68.47) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(4502.014 2602.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M-425.2,394.8h-43.008a32.2,32.2,0,0,0,.185,3.377,1.588,1.588,0,0,0,1.545,1.26,6.136,6.136,0,0,0,.712.01h30.14c.19,0,.38,0,.57,0,.487-.012.875.13.861.7-.013.525-.388.637-.843.636-2.233-.006-4.465,0-6.7,0h-.877c.136,1.347.261,2.612.393,3.877.074.708.182,1.413.233,2.122.032.443.192.633.657.61.64-.032,1.282,0,1.923-.01.476-.01.828.163.81.666-.017.483-.367.666-.84.665q-4.026-.009-8.052,0c-2.114,0-4.228.016-6.341-.019a1.222,1.222,0,0,1-.868-.419c-.284-.4.062-.858.631-.879.688-.025,1.379.018,2.065-.026.2-.013.543-.2.56-.343.254-2.043.465-4.092.7-6.241h-.926c-4.726,0-9.454-.061-14.179.025a3.418,3.418,0,0,1-3.664-3.648c.065-7.078.026-14.157.027-21.235,0-2.382,1.261-3.648,3.64-3.65,2.3,0,4.6,0,6.986,0,.074-1.231.924-1.714,1.895-2.165a6.437,6.437,0,0,0,3.805-4.831c.329-1.678.933-2.164,2.619-2.164q3.954,0,7.909,0a2.1,2.1,0,0,1,2.409,1.985,6.6,6.6,0,0,0,4.126,5.147,2.446,2.446,0,0,1,1.587,1.686c.04.158.417.324.64.327,2.113.025,4.227.013,6.341.015a3.289,3.289,0,0,1,3.648,3.655c0,7.1-.033,14.2.023,21.306a3.326,3.326,0,0,1-3.524,3.558c-1.137-.057-2.28-.014-3.42-.008-.463,0-.9-.054-.9-.642,0-.611.445-.7.944-.692,1.187.009,2.375.011,3.562,0a1.858,1.858,0,0,0,1.994-1.94C-425.18,396.631-425.2,395.755-425.2,394.8Zm-42.97-1.413h42.927c.018-.159.042-.274.042-.388q0-8.693,0-17.385a1.873,1.873,0,0,0-2.045-1.966c-2.09-.005-4.18.025-6.269-.016-.751-.015-1.086.074-1.262.982-1.336,6.9-5.512,11.764-11.29,15.439a.936.936,0,0,1-1.116.041,24.252,24.252,0,0,1-10.577-12.441c-.463-1.279-.722-2.632-1.089-4.006h-7c-1.679,0-2.315.636-2.316,2.321q0,8.3,0,16.6Zm32.326-20.836c.1-.469-.173-.8-.776-1.075a8.07,8.07,0,0,1-4.933-6.25.837.837,0,0,0-.918-.788q-4.2-.007-8.4,0a.845.845,0,0,0-.928.785,8.011,8.011,0,0,1-4.986,6.278.992.992,0,0,0-.7,1.211,33.285,33.285,0,0,0,.844,4.092c1.68,5.143,5.164,8.863,9.6,11.777a.982.982,0,0,0,.863-.058A25.059,25.059,0,0,0-440.3,383.3,19,19,0,0,0-435.844,372.551Zm-13.533,28.264-.741,6.511h6.871c-.254-2.208-.5-4.358-.749-6.511Z",
    transform: "translate(0)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M-243.6,533.277c-1.305,0-2.61,0-3.915,0-.458,0-.821-.112-.823-.648s.351-.657.814-.656q3.915.009,7.831,0c.428,0,.772.1.786.6.015.517-.3.7-.776.7C-240.986,533.273-242.291,533.277-243.6,533.277Z",
    transform: "translate(-189.661 -144.805)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M-431.652,531.972c1.3,0,2.61,0,3.915,0,.459,0,.817.1.806.653s-.363.652-.823.651q-3.879-.008-7.758,0c-.451,0-.833-.091-.846-.626-.014-.576.378-.683.863-.679C-434.214,531.979-432.933,531.972-431.652,531.972Z",
    transform: "translate(-28.431 -144.798)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M-432.99,509.381c-.855,0-1.71-.008-2.564,0-.468.006-.817-.13-.807-.66.009-.466.311-.66.757-.659q2.635,0,5.271,0c.456,0,.745.217.736.675s-.293.654-.757.645C-431.233,509.369-432.112,509.381-432.99,509.381Z",
    transform: "translate(-28.428 -124.301)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M-226.148,509.379c-.878,0-1.755-.007-2.632,0-.456.005-.745-.173-.736-.653s.3-.666.746-.666q2.633,0,5.265,0c.445,0,.742.19.738.667s-.3.654-.748.65C-224.393,509.374-225.271,509.379-226.148,509.379Z",
    transform: "translate(-205.796 -124.3)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M-365.993,401.844c4.006-3.043,6.962-6.651,7.99-11.592a.75.75,0,0,0-.4-.925,10.186,10.186,0,0,1-4.575-5.61.581.581,0,0,0-.66-.464q-2.279.029-4.558,0a.627.627,0,0,0-.72.492,10.1,10.1,0,0,1-4.528,5.561.817.817,0,0,0-.421,1.043,16.445,16.445,0,0,0,2.163,5.379c.1.161.209.317.309.478.238.382.321.78-.1,1.065s-.787.088-1-.318a36.828,36.828,0,0,1-1.846-3.6,28.105,28.105,0,0,1-.959-3.485,1.119,1.119,0,0,1,.676-1.434,8.868,8.868,0,0,0,4.6-5.612,1.038,1.038,0,0,1,1.208-.884c1.97.044,3.941.031,5.911.006a.886.886,0,0,1,1.014.746,9.026,9.026,0,0,0,4.774,5.813c.73.375.62.931.523,1.512a17.263,17.263,0,0,1-2.4,6.342,23.532,23.532,0,0,1-6.284,6.617.9.9,0,0,1-1.273.006c-1.114-.958-2.241-1.9-3.353-2.862-.377-.326-.61-.734-.161-1.151.412-.383.766-.119,1.11.2C-367.992,400.062-367,400.938-365.993,401.844Z",
    transform: "translate(-80.729 -16.15)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M-325.286,421.786a2.727,2.727,0,0,1-.929,1.889,1.277,1.277,0,0,0-.453,1.116c.025.616.022,1.234,0,1.851a1.721,1.721,0,0,1-1.79,1.8,1.722,1.722,0,0,1-1.74-1.843c-.009-.356-.012-.712,0-1.068a2.6,2.6,0,0,0-.7-2.167,2.885,2.885,0,0,1-.123-3.683,3.156,3.156,0,0,1,3.515-1.23A3.351,3.351,0,0,1-325.286,421.786Zm-3.575,3.382a8.863,8.863,0,0,0,.021,1.348c.033.214.283.4.434.591.128-.193.356-.379.367-.579a21.6,21.6,0,0,0,.01-2.274,1.375,1.375,0,0,1,.67-1.362,1.738,1.738,0,0,0,.274-2.62,1.812,1.812,0,0,0-2.655-.065,1.757,1.757,0,0,0,.22,2.677,1.313,1.313,0,0,1,.663,1.358A8.8,8.8,0,0,0-328.86,425.168Z",
    transform: "translate(-118.239 -47.336)",
    fill: "#543af4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidericonh4);
export default __webpack_public_path__ + "static/media/slidericonh4.48055697e6951cdbaa0120e977fc5ea7.svg";
export { ForwardRef as ReactComponent };